const env = process.env.REACT_APP_ENV;

const insuranceSubProducts = {
  HOGAR: {
    desa: {
      3320: {
        desc: 'Construcción <b>100% de material no inflamable</b>',
        img: require('../img/hogar_no_inflamable.svg'),
      },
      3324: {
        desc: 'Hay que borrar esto desde el backend',
        img: require('../img/House.svg'),
      },
      3330: {
        desc: 'Construcción <b>al menos de 40% en material no inflamable</b>',
        img: require('../img/hogar_madera.svg'),
      },
      3322: {
        desc: 'Construcción <b>100% de material no inflamable</b>',
        img: require('../img/hogar_no_inflamable.svg'),
      },
    },
    testing: {
      3320: {
        desc: 'Construcción <b>100% de material no inflamable</b>',
        img: require('../img/hogar_no_inflamable.svg'),
      },
      3324: {
        desc: 'Hay que borrar esto desde el backend',
        img: require('../img/House.svg'),
      },
      3322: {
        desc: 'Construcción <b>al menos de 40% en material no inflamable</b>',
        img: require('../img/hogar_madera.svg'),
      },
      3321: {
        desc: 'Construcción <b>100% de material no inflamable</b>',
        img: require('../img/hogar_no_inflamable.svg'),
      },
    },
    prod: {
      3320: {
        desc: 'Construcción <b>100% de material no inflamable</b>',
        img: require('../img/hogar_no_inflamable.svg'),
      },
      3324: {
        desc: 'Hay que borrar esto desde el backend',
        img: require('../img/House.svg'),
      },
      3322: {
        desc: 'Construcción <b>al menos de 40% en material no inflamable</b>',
        img: require('../img/hogar_madera.svg'),
      },
      3321: {
        desc: 'Construcción <b>100% de material no inflamable</b>',
        img: require('../img/hogar_no_inflamable.svg'),
      },
    },
  },

  // TODO: Add the products code for TECNO and Change this unnecessary logic if for TECNO the
  // products have the same codes by env
  TECNO: {
    desa: {
      3370: {
        desc: 'Asegurá tu <b>smartphone</b>',
        img: require('../img/tecno_cel.svg'),
      },
      3375: {
        desc: 'Asegurá tu <b>smartphone</b>, <b>notebook</b> o <b>tablet</b>',
        img: require('../img/tecno_tech.svg'),
      },
      3371: {
        desc: 'Asegurá tu <b>smartphone</b>',
        img: require('../img/tecno_cel.svg'),
      },
      3376: {
        desc: 'Asegurá tu empleado <b>smartphone</b>, <b>notebook</b> o <b>tablet</b>',
        img: require('../img/tecno_tech.svg'),
      },
    },
    testing: {
      3370: {
        desc: 'Asegurá tu <b>smartphone</b>',
        img: require('../img/tecno_cel.svg'),
      },
      3375: {
        desc: 'Asegurá tu <b>smartphone</b>, <b>notebook</b> o <b>tablet</b>',
        img: require('../img/tecno_tech.svg'),
      },
      3371: {
        desc: 'Asegurá tu <b>smartphone</b>',
        img: require('../img/tecno_cel.svg'),
      },
      3376: {
        desc: 'Asegurá tu empleado <b>smartphone</b>, <b>notebook</b> o <b>tablet</b>',
        img: require('../img/tecno_tech.svg'),
      },
    },
    prod: {
      3370: {
        desc: 'Asegurá tu <b>smartphone</b>',
        img: require('../img/tecno_cel.svg'),
      },
      3375: {
        desc: 'Asegurá tu <b>smartphone</b>, <b>notebook</b> o <b>tablet</b>',
        img: require('../img/tecno_tech.svg'),
      },
      3371: {
        desc: 'Asegurá tu <b>smartphone</b>',
        img: require('../img/tecno_cel.svg'),
      },
      3376: {
        desc: 'Asegurá tu <b>smartphone</b>, <b>notebook</b> o <b>tablet</b>',
        img: require('../img/tecno_tech.svg'),
      },
    },
  },
};

const getSubProducts = (insuranceName) =>
  (insuranceSubProducts[insuranceName] &&
    insuranceSubProducts[insuranceName][env]) ||
  {};

const insurances = {
  'PERTENENCIAS PROTEGIDAS': {
    url: '/pertenencias-protegidas',
    logo: require('../img/pp.svg'),
    title: 'Protegé tus <b>PERTENENCIAS</b>',
    subProducts: getSubProducts('PERTENENCIAS PROTEGIDAS'),
  },
  'ROBO EN CAJERO AUTOMATICO': {
    url: '/robo-en-cajero-automatico',
    logo: require('../img/P24.svg'),
    title: 'Asegurá tu <b>EXTRACCIÓN</b> las 24hs',
    subProducts: getSubProducts('ROBO EN CAJERO AUTOMATICO'),
  },
  MASCOTA: {
    url: '/mascota',
    logo: require('../img/Pets.svg'),
    title: 'Protegé a <b>TU MEJOR AMIGO</b>',
  },
  'VIDA INDIVIDUAL': {
    url: '/vida',
    logo: require('../img/Life.svg'),
    title: 'Asegurá tu <b>VIDA</b> y el futuro de los que más querés',
    subProducts: getSubProducts('VIDA INDIVIDUAL'),
  },
  'ACCIDENTES PERSONALES': {
    url: '/accidentes-personales',
    logo: require('../img/AP.svg'),
    title: 'Cuidá tu futuro, asegurate ante un <b>ACCIDENTE</b>',
    subProducts: getSubProducts('ACCIDENTES PERSONALES'),
  },
  'ACCIDENTES PERSONALES PYME': {
    url: '/accidentes-personales-pyme',
    img: require('../img/pp_old.svg'),
  },
  AUTOMOTORES: {
    url: '/automotores',
    logo: require('../img/Car.svg'),
  },
  HOGAR: {
    logo: require('../img/Vector.svg'),
    title: 'Tu <b>HOGAR</b> bien protegido',
    img: require('../img/House.svg'),
    url: '/hogar',
    type: 'hogar',
    subTitle: 'Elegí el <b>Tipo de Construcción</b> que querés asegurar',
    subProducts: getSubProducts('HOGAR'),
  },
  'INTEGRAL DE COMERCIO': {
    logo: require('../img/IC.svg'),
    url: '/integral-comercio',
    title: 'Protege tu <b>COMERCIO</b>',
    subTitle: 'Elegí la actividad que mejor describa tu negocio',
  },
  TECNO: {
    url: '/tecno',
    logo: require('../img/tecno_tech.svg'),
    title: 'Tus <b>Equipos</b> bien protegidos',
    subTitle: 'Elegí qué <b>Equipos</b> querés asegurar',
    subProducts: getSubProducts('TECNO'),
  },
  'MOVILIDAD': {
    url: '/movilidad',
    logo: require('../img/movi.svg'),
    title: 'Tu <b>MOVILIDAD</b> bien protegida',
    subTitle: '',
    subProducts: getSubProducts('MOVILIDAD'),
  },
  AUTOMOTOR: {
    url: '/automotor',
    logo: require('../img/Car.promo.svg'),
    title: 'Asegurá tu <b>AUTO</b>',
    subTitle:
      '<b>Completá los datos de tu auto</b> y conocé los planes que tenemos para vos',
  },
};

export function getInsuranceLocalInfo(insuranceId) {
  return insurances[insuranceId] || {};
}
